import { apiGet } from '../_common';

export default {
  getAll() {
    return apiGet('/magenta/stock/stock-physical-address')
      .then(result => result.response);
  },
};
